import { CART_MODULE } from "@/api_framework/api_config";
import { IHDItemSearchResponse, IHDItemSearchResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: any };

export const useHDCartSearchAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<IHDItemSearchResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const clearSearchResults = () => {
    setData([]);
  };

  const execute = useCallback(
    async (query: string, pincode: string, searchTag: string) => {
      dispatch(
        setLoading({
          key: "isCustomerCartItemsSearchInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${CART_MODULE?.HD_CART_SEARCH?.baseURL}`, {
            params: {
              pincode: pincode,
              search_tag: searchTag,
              search_keyword: query,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IHDItemSearchResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              dispatch(
                setLoading({
                  key: "isCustomerCartItemsSearchInProgress",
                  status: false,
                }),
              );
              return { status: true, message: res.data.data };
            } else {
              setData([]);
              dispatch(
                setLoading({
                  key: "isCustomerCartItemsSearchInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "cart_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerCartItemsSearchInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCustomerCartItemsSearchInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { data, execute, clearSearchResults };
};
